import { ReactNode, useMemo, useState } from 'react';

import { createCtx } from '@pletly/ui';
import { ClientApp } from '../__generated__/types';

interface AvailableUpdateType {
	isRequired: boolean;
	version: string;
	releaseNotes: string;
}

type UpdateCheckState =
	| {
			status: 'not-checked';
	  }
	| {
			status: 'loading';
	  }
	| {
			status: 'error';
			error: unknown;
	  }
	| {
			status: 'success';
			availableUpdate: AvailableUpdateType | null;
	  };

type ContextType = {
	updateInfo: UpdateCheckState;
	setUpdateInfo: (updateInfo: UpdateCheckState) => void;
	app: ClientApp;
};

const [useAppUpdateInfo, AppUpdateInfoDataProvider] = createCtx<ContextType>();

const AppUpdateInfoProvider = ({ app, children }: { app: ClientApp; children?: ReactNode }) => {
	const [updateInfo, setUpdateInfo] = useState<UpdateCheckState>({ status: 'not-checked' });
	const contextValue = useMemo(() => ({ updateInfo, setUpdateInfo, app }), [updateInfo, app]);

	return <AppUpdateInfoDataProvider value={contextValue}>{children}</AppUpdateInfoDataProvider>;
};

export { useAppUpdateInfo, AppUpdateInfoProvider };
